export const level_one_mapping = {
    CHOCOLATS: ["hot_beverage_type"],
    CIDRES: ["cider_type", "cider_head_type", "cider_flavor", "cider_region"],
    "SOFT DRINKS": ["soft_family"],
    VINS: [
        "wine_color",
        "wine_vineyard",
        "wine_denomination",
        "wine_appellation",
        "wine_millesime",
        "wine_sugar_content",
        "wine_grape",
    ],
    "SIROP ET CONCENTRES": ["sirop_family", "flavour"],
    "LAITS ET SAUCES": ["grocery_type"],
    "SUCRES ET ACCOMPAGNEMENTS": ["grocery_type"],
    SPIRITUEUX: [
        "spirit_family",
        "spirit_type",
        "spirit_millesime",
        "spirit_age",
        "spirit_region",
    ],
    HYGIENES: ["hygiene_type"],
    CIDERS: ["cider_type", "cider_head_type", "cider_flavor", "cider_region"],
    SNACKING: [
        "wine_color",
        "wine_vineyard",
        "wine_denomination",
        "wine_appellation",
        "wine_millesime",
        "wine_sugar_content",
        "wine_grape",
    ],
    "JUS DE FRUITS": ["juice_family"],
    ASSAISONNEMENTS: [
        "wine_color",
        "wine_vineyard",
        "wine_denomination",
        "wine_appellation",
        "wine_millesime",
        "wine_sugar_content",
        "wine_grape",
    ],
    BIERES: [
        "beer_color",
        "beer_family",
        "beer_style",
        "beer_flavor",
        "beer_region",
        "beer_head_type",
        "beer_bitterness",
        "gluten_free_beer",
    ],
    MATERIELS: ["material_type"],
    "THES ET INFUSIONS": ["tea_type", "tea_color", "tea_flavor", "tea_label"],
    EAUX: ["water_family"],
    CAFES: [
        "coffee_type",
        "decaf_coffee",
        "coffee_pod_type",
        "coffee_roasting_region",
        "coffee_roast",
        "coffee_variety",
        "coffee_ingredients",
        "coffee_intensity",
        "coffee_label",
    ],
};
